<div class="flex flex-col items-center justify-center w-screen h-screen bg-chathams-blue">
  <div class="max-w-sm h-auto m-0">
    <img src="assets/images/logo-login.png" alt="Olive logo" />
  </div>

  <div *ngIf="keycloak; else formularioLegado" class="mx-2 w-72">
    <button type="button" class="w-full h-10 mt-4 btn btn--secondary" (click)="entrarPeloKeycloak()">Entrar</button>
  </div>

  <ng-template #formularioLegado>
    <form class="mx-2" [formGroup]="loginForm" (ngSubmit)="login()">
      <input class="form-input-custom" type="email" placeholder="E-mail" formControlName="email" />

      <input class="form-input-custom" type="password" placeholder="Senha" formControlName="password" />

      <button type="submit" class="w-full h-10 mt-4 btn btn--secondary">Entrar</button>
      <div class="flex justify-center">
        <a class="text-center text-white underline font-bold pt-4" routerLink="esqueceu-senha">Esqueceu a senha?</a>
      </div>
    </form>
  </ng-template>
</div>
